import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight, MapPin, Mail, Phone } from 'lucide-react';

const HeroSection = ({ onBookClick }) => {
  return (
    <section
      id="hero"
      className="relative min-h-[90vh] md:min-h-screen flex items-end overflow-hidden pb-16 md:pb-20"
      data-testid="hero-section"
    >
      {/* Background Image - different for mobile and desktop */}
      <div className="absolute inset-0 z-0">
        {/* Desktop background */}
        <img
          src="/images/fizioterapija-obravnava-pacienta-ljubljana.avif"
          alt="Fizioterapija obravnava pacienta v Ljubljani"
          className="hidden md:block w-full h-full object-cover object-[40%_center]"
          loading="eager"
          fetchPriority="high"
        />
        {/* Mobile background - new image, positioned to show physiotherapist */}
        <img
          src="/images/fizioterapija-anatomija-plakat.png"
          alt="Fizioterapija posvet Ljubljana"
          className="block md:hidden w-full h-full object-cover object-[70%_25%]"
          loading="eager"
          fetchPriority="high"
        />
        {/* Light overlay - mobile only */}
        <div className="absolute inset-0 bg-gradient-to-r from-white/70 via-white/40 to-transparent md:hidden" />
        {/* Light overlay - desktop - more transparent */}
        <div className="absolute inset-0 hidden md:block bg-gradient-to-r from-white/20 via-white/30 to-white/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-3xl">
          {/* Main Title */}
          <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-extrabold text-[#1a365d] leading-tight mb-6 md:mb-8 animate-fade-in-up">
            Naj bo vaše zdravje
            <span className="block text-[#f87171]">v dobrih rokah.</span>
          </h1>

          {/* Contact Info */}
          <div className="flex flex-col sm:flex-row sm:flex-wrap gap-3 sm:gap-6 mb-6 md:mb-8 animate-fade-in-up delay-200">
            <a 
              href="tel:+38640464886"
              className="flex items-center gap-2 text-slate-600 hover:text-[#f87171] transition-colors text-sm"
            >
              <Phone className="w-4 h-4 text-[#f87171]" />
              <span>+386 40 464 886</span>
            </a>
            <a 
              href="https://maps.app.goo.gl/LMh3RZepmt6NsNaL8" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hidden sm:flex items-center gap-2 text-slate-600 hover:text-[#f87171] transition-colors text-sm"
            >
              <MapPin className="w-4 h-4 text-[#f87171]" />
              <span>Dunajska c. 154, Ljubljana</span>
            </a>
            <a 
              href="mailto:fizioterapija@sasapanic.com"
              className="flex items-center gap-2 text-slate-600 hover:text-[#f87171] transition-colors text-sm"
            >
              <Mail className="w-4 h-4 text-[#f87171]" />
              <span>fizioterapija@sasapanic.com</span>
            </a>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 animate-fade-in-up delay-300">
            <Button
              onClick={onBookClick}
              className="bg-[#f87171] hover:bg-[#f87171]/90 text-white rounded-full px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg font-semibold btn-lift animate-pulse-coral"
              data-testid="hero-book-btn"
            >
              Rezervirajte termin
              <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <Button
              variant="outline"
              onClick={() => document.querySelector('#storitve')?.scrollIntoView({ behavior: 'smooth' })}
              className="hidden sm:flex border-2 border-[#1a365d] text-[#1a365d] hover:bg-[#1a365d] hover:text-white rounded-full px-8 py-6 text-lg font-semibold btn-lift bg-white/50"
              data-testid="hero-services-btn"
            >
              Oglejte si storitve
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator - hidden on mobile */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce hidden md:block">
        <div className="w-6 h-10 border-2 border-slate-400 rounded-full flex justify-center pt-2">
          <div className="w-1.5 h-3 bg-slate-500 rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
